var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPlinkedinicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_801_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.997,
    height: 13.966,
    viewBox: "0 0 13.997 13.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    d: "M7.963,99.73H5.153a.226.226,0,0,0-.226.226v9.027a.226.226,0,0,0,.226.226h2.81a.226.226,0,0,0,.226-.226V99.956A.226.226,0,0,0,7.963,99.73Z",
    transform: "translate(-4.705 -95.243)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    d: "M1.854.341A1.852,1.852,0,1,0,3.707,2.193,1.855,1.855,0,0,0,1.854.341Z",
    transform: "translate(0 -0.341)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    d: "M111.787,94.761a3.3,3.3,0,0,0-2.469,1.036v-.586a.226.226,0,0,0-.226-.226H106.4a.226.226,0,0,0-.226.226v9.027a.226.226,0,0,0,.226.226h2.8a.226.226,0,0,0,.226-.226V99.772c0-1.5.409-2.091,1.458-2.091,1.143,0,1.233.94,1.233,2.169v4.389a.226.226,0,0,0,.226.226h2.8a.226.226,0,0,0,.226-.226V99.287C115.379,97.049,114.952,94.761,111.787,94.761Z",
    transform: "translate(-101.382 -90.498)",
    ffill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPlinkedinicon);
export default __webpack_public_path__ + "static/media/LPlinkedinicon.54544db9939ea756bb18d92ecdc2e95a.svg";
export { ForwardRef as ReactComponent };